import { Column } from 'farmhub-ui-core';

import AccountInformationItemSkeleton from 'components/Skeleton/AccountInformationItemSkeleton';
import { getFullAddress } from 'utils';

import AccountInformationItem from '../components/AccountInformationItem';
import HeaderElectronicBill from '../components/HeaderElectronicBill';
import OrderInformationOther from '../components/OrderInformationOther';
import OrderInformationSection from '../components/OrderInformationSection';
import { SettingBillSectionInformation } from '../components/SettingBillSection/interfaces';
import TitleElectronicBill from '../components/TitleElectronicBill';
import GroupProductTable from '../PaymentBillContent/components/GroupProductTable';
import { WaterMark } from './styles';

interface ContentToPrintProps {
  order: any;
  setting: SettingBillSectionInformation;
  isLoading: boolean;
  isCart?: boolean;
}

const ContentToPrint = ({
  order,
  setting,
  isLoading,
  isCart = false,
}: ContentToPrintProps): JSX.Element => (
  <WaterMark id="A4Content" url={order.supplier?.avatar}>
    <Column styles={{ zIndex: 1, position: 'relative', gap: 18 }}>
      {setting.visibleSupplier && (
        <HeaderElectronicBill isPrint data={order} isLoading={isLoading} />
      )}
      <TitleElectronicBill
        isPrint
        isCart={isCart}
        isLoading={isLoading}
        subTitle={`Mã ĐH: #${order.code}`}
        title="HÓA ĐƠN BÁN HÀNG"
      />
      {setting.visibleInformation && (
        <OrderInformationOther
          isPrint
          data={order}
          isCart={isCart}
          isLoading={isLoading}
        />
      )}
      {(setting.visibleCustomer || setting.visibleReceive) && (
        <OrderInformationSection
          isPrint
          isLoading={isLoading}
          title="Thông tin khách hàng"
        >
          {isLoading ? (
            <>
              <AccountInformationItemSkeleton />
              <AccountInformationItemSkeleton />
            </>
          ) : (
            <>
              <AccountInformationItem
                isPrint
                data={{
                  avatar: order.customer?.avatar,
                  name: order.customer?.displayName,
                  address: getFullAddress(
                    order.customer?.address,
                    order.customer?.ward?.district?.fullName,
                    order.customer?.ward?.province?.fullName,
                    order.customer?.ward?.fullName
                  ),
                  phoneNumber: order.customer?.phoneNumber,
                  role: 'Khách hàng',
                }}
              />
              <AccountInformationItem
                isPrint
                data={{
                  avatar: order.customer?.avatar,
                  name: order.additionalInfo?.address?.title,
                  address: getFullAddress(
                    order.additionalInfo?.address?.address,
                    order.additionalInfo?.address?.district?.fullName,
                    order.additionalInfo?.address?.province?.fullName,
                    order.additionalInfo?.address?.ward?.fullName
                  ),
                  phoneNumber: order.additionalInfo?.address?.phoneNumber,
                  role: 'Người nhận',
                }}
              />
            </>
          )}
        </OrderInformationSection>
      )}
      <GroupProductTable isLoading={isLoading} order={order} />
    </Column>
  </WaterMark>
);

export default ContentToPrint;
